import React from "react";

import "./mobileSupport.css";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { SupportNumber } from "../../utilities/support";

const MobileSupport = () => {
  // Mobile Responsive
  const [windowDimension, setWindowDimension] = useState(null);

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowDimension <= 640;
  // Mobile Responsive
  const handleCall = () => {
    window.location.href = `tel:+${SupportNumber}`;
  };

  const handleWhatsApp = () => {
    const url = `https://wa.me/${SupportNumber}`;
    window.open(url, "_blank");

  };

  return (
    <div className="mobileSupport">
      <div className="mobileSupport-wrapper">
        {isMobile ? (
          <div className="mobileSupport-top-goback">
            <Link to="/mobile-profile">
              <div className="arrow">
                <ArrowBackIosIcon className="icon" />
              </div>
              <p>Support</p>
            </Link>
          </div>
        ) : (
          <div className="mobileSupport-top-goback">
            <Link to="/">
              <div className="arrow">
                <ArrowBackIosIcon className="icon" />
              </div>
              <p>Support</p>
            </Link>
          </div>
        )}

        <div className="mobileSupport-middle">
          <div className="mobileSupport-middle-content">
            <h3>We are happy to help you</h3>
            <p>For further queries contact us.</p>
          </div>
        </div>
        <div className="mobileSupport-bottom">
          <div className="mobileSupport-bottom-content">
            <button onClick={handleCall}>CALL</button>
            <button onClick={handleWhatsApp}>WHATSAPP</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileSupport;
